import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Form } from 'react-bootstrap';

import axiosInstance from '../../../../services/AxiosInstance';
var bnr1 = require('./../../../../images/main-slider/slide2.jpg');

function Banner() {

    const history = useHistory();

    const [categories, setCategories] = useState();
    const [total, setTotal] = useState();
    const [input, setInput] = useState({
        title: '',
        place: '',
        job_categories: ''
    });

    useEffect(() => {
        axiosInstance('job-categories/?fields=id,name', { method: "GET" })
            .then(res => { if (res?.status === 200) setCategories(res?.data?.results) })
        axiosInstance('post-jobs/total/', { method: "GET" })
            .then(res => { if (res?.status === 200) setTotal(res?.data) })
    }, []);

    const handleInput = (e, dr) => {
        if (dr) {
            var option = document.getElementById("cities").value
            setInput({ ...input, 'job_categories': option })
        }
        else setInput({ ...input, [e.target.name]: e.target.value })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        var base64 = btoa(JSON.stringify(input));
        history.push(`/browse-job-list/${base64}`);
    }

    return (
        <div className="dez-bnr-inr dez-bnr-inr-md" style={{ backgroundImage: "url(" + bnr1 + ")" }}>
            <div className="container">
                <div className="dez-bnr-inr-entry align-m">
                    <div className="find-job-bx">
                        <Link to={"/browse-job-list"} className="site-button button-sm">Find Jobs, Employment & Career Opportunities</Link>
                        <h2>Search Between More Then <br /> <span className="text-primary">{total}</span> Open Jobs.</h2>
                        <form className="dezPlaceAni" onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-4 col-md-6">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Job Title, Keywords, or Phrase"
                                                name='title'
                                                value={input?.title || ''}
                                                onChange={handleInput}
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text"><i className="fa fa-search"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Place, Country.."
                                                name='place'
                                                value={input?.place || ''}
                                                onChange={handleInput}
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text"><i className="fa fa-map-marker"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6">
                                    <div className="form-group">
                                        <Form.Control as="select" custom className="select-btn" id='cities' onChange={(e) => handleInput(e, 'dr')}>
                                            <option value={null}>Select Sector</option>
                                            {categories?.map(res =>
                                                <option key={res.name} value={res.id}>{res.name}</option>
                                            )}
                                        </Form.Control>

                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-6">
                                    <button className="site-button btn-block" onClick={handleSubmit}>Find Job</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div >
        </div >
    );
}

export default Banner;